import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',

    '& .applied-filter': {
      '&-container': {
        margin: theme.spacing(0, 2),
      },
      '&-chip': {
        paddingLeft: theme.spacing(1),
        height: theme.spacing(9 / 2),
        borderRadius: theme.spacing(9 / 4),
      },
      '&-text': {
        marginRight: theme.spacing(1),
        lineHeight: 1,
      },
    },
    '& .button-refresh': {
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing(1),
    },
  },
}));

export default styles;
